module.exports = __webpack_public_path__ + "static/media/html.7b9c56c0.png";